export default __webpack_public_path__ + "static/media/kiosk.3ad75d45.svg";